export default __webpack_public_path__ + "static/media/Martha Anderson.1b48570d.mp3";